<template>
    <a @click="clickHandler($event)" class="clickable delete-button">
        <fa-icon icon="trash-alt"></fa-icon> {{caption || 'Delete'}}
    </a>
</template>

<script>
export default {

  name: 'DeleteButton',

  props: {
    url: String,
    caption: String,
  },

  methods: {
    clickHandler: function(event) {
        event.preventDefault();

        if (confirm('Are you sure you want to delete this?')) {
            const form = $('<form>')
                .css('display', 'none')
                .attr('action', this.url)
                .attr('method', 'post');
            const method = $('<input />')
                .attr('value', 'DELETE')
                .attr('name', '_method')
                .appendTo(form);
            const csrf = $('<input />')
                .attr('name', '_token')
                .val($('meta[name=csrf-token]').attr('content'))
                .appendTo(form);

            form.appendTo($('body')).submit();
        }
    }
  }
};
</script>
